/******/ (() => { // webpackBootstrap
class ScrollingBanner extends HTMLElement {
  constructor() {
    super();
    this.duplicatedLinks = this.querySelectorAll('ol[data-duplicated] a');
  }

  connectedCallback() {
    this.init();
    this.initToggle();
  }

  init() {
    this.duplicatedLinks.forEach(link => {
      link.setAttribute('tabindex', '-1'); //prevents focusing on a duplicated link on keyboard nav
    });
  }

  initToggle() {
    // WCAG 2.2.2: visible, keyboard-operable pause control for this auto-scrolling ticker.
    const wrapper = this.closest('.scrolling-banner__wrapper');
    const toggle = wrapper && wrapper.querySelector('.scrolling-banner__toggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const isPaused = this.hasAttribute('data-scrolling-paused');

      if (isPaused) {
        this.removeAttribute('data-scrolling-paused');
        toggle.classList.remove('is-paused');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', 'Pause automatic scrolling');
      } else {
        this.setAttribute('data-scrolling-paused', '');
        toggle.classList.add('is-paused');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', 'Resume automatic scrolling');
      }
    });
  }

}

// Only define the custom element if it doesn't already exist
if (!customElements.get('scrolling-banner')) customElements.define('scrolling-banner', ScrollingBanner);

/******/ })()
;